import 'formdata-polyfill';
import 'url-search-params-polyfill';
import axios from 'axios';
// import loadHandler from '../../../visual/src/helpers/loadHandler';
import Observer from 'common/scripts/observer';
import Utils from 'common/scripts/utils';
import Vue from 'vue';
import Vuex from 'vuex';

// eslint-disable-next-line no-process-env
const dev = process.env.NODE_ENV === 'development';
const url = dev ? '/tests/parametric/init.json' : '/api/estateSearch/';
// const url = '/tests/parametric/init.json';
const observer = new Observer();
const defaultPage = 1;

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        view   : '',
        isReady: false,
        isProc : false,
        sliders: {
            area  : {},
            price : {},
            floors: {}
        },
        canvasSize: {
            width : 0,
            height: 0
        },
        filters        : {},
        building       : {},
        selectedObjects: [],
        allFlats       : {},
        flats          : [],
        page           : Utils.getUrlParams('page') || defaultPage,
        sort           : {
            type : Utils.getUrlParams('sort') || 'price',
            order: Utils.getUrlParams('order') || 'asc'
        },
        formData    : '',
        selected    : [],
        render      : '',
        estateType  : '',
        hiddenPrices: false
    },

    getters: {
        GET_VIEW(state) {
            return state.view;
        },

        GET_IS_PROCESSING(state) {
            return state.isProc;
        },

        GET_IS_READY(state) {
            return state.isReady;
        },

        GET_SLIDERS(state) {
            return state.sliders;
        },

        GET_BUILDING(state) {
            return state.building;
        },

        GET_FILTERS(state) {
            return state.filters;
        },

        GET_FLATS(state) {
            const sortType = state.sort.type;
            const sortOrder = state.sort.order;

            return state.flats.sort((a, b) => {
                const valA = a.isBooked || !Number(a[sortType]) ? null : a[sortType];
                const valB = b.isBooked || !Number(b[sortType]) ? null : b[sortType];

                if (valA === null) {
                    return 1;
                } else if (valB === null) {
                    return -1;
                }

                return sortOrder === 'desc' ? valB - valA : valA - valB;
            });
        },

        GET_PAGE(state) {
            return state.page;
        },

        GET_SORT(state) {
            return state.sort;
        },

        GET_FORM_DATA(state) {
            return state.formData;
        },

        GET_ESTATETYPE(state) {
            return state.estateType;
        },

        GET_CANVAS_SIZE(state) {
            return state.canvasSize;
        },

        GET_SELECTED_BUILDINGS(state) {
            return state.selected;
        },

        GET_SELECTED_OBJECTS(state) {
            return state.selectedObjects;
        },

        GET_RENDER(state) {
            return state.render;
        },

        GET_HIDDENPRICES(state) {
            return state.hiddenPrices;
        }
    },

    actions: {
        // Событие происходит при загрузке приложения
        initApp(context, body) {
            context.commit('SET_IS_PROCESSING', true);
            context.commit('SET_ESTATETYPE');
            context.commit('SET_VIEW');
            context.commit('SET_FORM_DATA', body);

            return new Promise(() => {
                axios.post(url, context.getters.GET_FORM_DATA)
                    .then((response) => {
                        context.commit('SET_IS_READY');
                        context.commit('SET_SLIDERS', response.data.data);
                        context.commit('SET_FILTERS', response.data.data);
                        context.commit('SET_FLATS', response.data.data);
                        context.commit('SET_BUILDING', response.data.data.filters);
                        context.commit('SET_CORPUSES', response.data.data.filters);
                        context.commit('SET_RENDER', response.data.data);
                        context.commit('SET_HIDDENPRICES', response.data.data);
                    })
                    .catch((error) => {
                        console.error(`При инициализации параметрического поиска произошла ошибка= ${error}`);
                    });
            });
        },

        // Событие происходит 1 раз при инициализации фильтра. Нужно обновить форм-дату.
        initFilter(context, body) {
            context.commit('SET_FORM_DATA', body);
        },

        // Событие происходит при изменении элементов формы.
        changeFilter(context, body) {
            context.commit('SET_IS_PROCESSING', true);
            context.commit('SET_FORM_DATA', body);
            context.commit('SET_GET_PARAMS');

            axios.post(url, context.getters.GET_FORM_DATA)
                .then((response) => {
                    context.commit('SET_SLIDERS', response.data.data);
                    context.commit('SET_FILTERS', response.data.data);
                    context.commit('SET_FLATS', response.data.data);
                    // context.commit('SET_BUILDING', response.data.data.filters);
                    context.commit('SET_CORPUSES', response.data.data.filters);
                    context.commit('UPDATE_BORDER_SLIDERS', response.data.data);
                    context.commit('SET_HIDDENPRICES', response.data.data);
                })
                .catch((error) => {
                    console.error(`При поиске квартир произошла ошибка= ${error}`);
                });
        },

        // Событие происходит при сбросе формы
        resetFilter(context, body) {
            context.dispatch('changeFilter', body);
        },

        // Событие происходит при обновлении дом элементов фильтра
        updateFilter(context) {
            context.commit('SET_IS_PROCESSING', false);
        },

        // Событие происходит при пагинации по клику на показать еще
        changePage(context) {
            context.commit('SET_PAGE');
        },

        // Событие происходит по смене типа и направления сортировки
        changeSort(context, body) {
            context.commit('SET_SORT', body);
        },

        // Событие происходит при выборе корпусов как в селекте, так и на визуальном(номера зданий)
        changeSelected(context, body) {
            context.commit('SET_SELECTED_BUILDINGS', body);
        },

        // Событие происходит при выборе корпусов как в селекте, так и на визуальном(номера зданий)
        closeSelected(context, body) {
            context.commit('SET_SELECTED_BUILDINGS_FROM_SELECT', body);
        }
    },

    mutations: {
        /**
         * Мутация устанавливает текущий вид результатов выдачи
         * @param {object} state - текущий стейт.
         */
        SET_VIEW(state) {
            const setup = (mql) => {
                state.view = mql.matches ? 'desktop' : 'mobile';
            };
            const mql = window.matchMedia(`screen and (min-width: ${this._vm.$appOptions.viewBreakpoint}px)`);

            mql.addListener(setup);
            setup(mql);
        },

        /**
         * Мутация меняет статус загрузки.
         * @param {object} state - текущий стейт.
         * @param {boolean} data - путь картинки
         */
        SET_CANVAS_SIZE(state, data) {
            state.canvasSize = data;
        },

        /**
         * Мутация меняет статус загрузки.
         * @param {object} state - текущий стейт.
         * @param {boolean} value - true/false
         */
        SET_IS_PROCESSING(state, value) {
            state.isProc = value;
        },

        /**
         * Мутация устанавливает ключ готовности - когда будут полностью отрисованы фильтры с данными.
         * @param {object} state - текущий стейт.
         */
        SET_IS_READY(state) {
            state.isReady = true;

            document.querySelector('.j-parametric-wrapper').classList.add('is-load');
        },

        /**
         * Мутация устанавливает форм-дату для отправки на сервер.
         * @param {object} state - текущий стейт.
         * @param {object} body - тело запроса, содержит в себе тип и дом-элемент формы
         */
        SET_FORM_DATA(state, body) {
            state.formData = new FormData(body.form);
            state.formData.append('type', body.type || false);
            state.formData.append('estateType', state.estateType);

            if (body.form) {
                for (const item of state.selected) {
                    state.formData.append(`building[${item}]`, 'on');
                }

                // Если с бэка пришел выбранный и задизейбленный фильтр (одновременно) добавляем его в форм дату
                const disabledArr = Array.from(body.form.querySelectorAll([':disabled']));

                disabledArr.forEach((item) => {
                    if (item.checked) {
                        state.formData.append(item.name, item.value);
                    }
                });
            }

            // если это первая загрузка (при ней нет формы), и не сброс фильтров
            if (!body.form && body.type !== 'reset') {
                if (window.location.search) {
                    const searchParams = new URLSearchParams(window.location.search);

                    for (const value of searchParams.entries()) {
                        state.formData.append(value[0], value[1]);
                    }
                }
            }

            // Убираем все пробелы из элементов форм-даты (числа с разрядами)
            for (const item of state.formData.entries()) {
                state.formData.set(item[0], Utils.replaceSpace(item[1]));
            }
        },

        /**
         * Мутация устанавливает гет-параметры в url, включает текущую форм-дату, и доп ключи такие как сортировка и номер страницы
         * @param {object} state - текущий стейт.
         */
        SET_GET_PARAMS(state) {
            const query = new URLSearchParams();

            for (const item of state.formData.entries()) {
                query.append(item[0], item[1]);
            }

            query.append('page', state.page);
            query.append('sort', state.sort.type);
            query.append('order', state.sort.order);

            // удаляем тип и гет-параметры раннее полученные из форм-даты
            query.delete('type');
            query.delete('getParams');

            window.history.pushState(null, null, `?${query.toString()}`);
        },

        /**
         * Мутация устанавливает данные от бека для слайдеров.
         * @param {object} state - текущий стейт.
         * @param {object} data - данные от сервера
         */
        SET_SLIDERS(state, data) {
            state.sliders = data.sliders;
        },

        /**
         * Мутация устанавливает данные от бека для фильтров.
         * @param {object} state - текущий стейт.
         * @param {object} data - данные от сервера
         */
        SET_FILTERS(state, data) {
            state.filters = data.filters;
        },

        /**
         * Мутация устанавливает данные от бека для select.
         * @param {object} state - текущий стейт.
         * @param {object} data - данные от сервера
         */
        SET_BUILDING(state, data) {
            state.building = data.building;
            state.selectedObjects = [];
            state.selected = [];
            // выбранные здания помещаем в другую переменную

            for (const item in data.building) {
                if ({}.hasOwnProperty.call(data.building, item)) {
                    if (data.building[item].checked || data.building[item].selected) {
                        state.selectedObjects.push(data.building[item]);

                        // eslint-disable-next-line no-unused-expressions
                        state.selected.includes(Number(data.building[item].id)) ?
                            state.selected.splice(state.selected.indexOf(Number(data.building[item].id)), 1) :
                            state.selected.push(Number(data.building[item].id));
                    }
                }
            }
        },

        /**
         * Мутация устанавливает данные от бека для select.
         * @param {object} state - текущий стейт.
         * @param {object} data - данные от сервера
         */
        SET_CORPUSES(state, data) {
            state.blocks = Object.values(data.blocks).map((block) => {
                return {
                    ...block,
                    selected: block.selected || false
                };
            });
        },

        /**
         * Мутация устанавливает данные от бека для фильтров.
         * @param {object} state - текущий стейт.
         * @param {object} data - данные от сервера
         */
        SET_RENDER(state, data) {
            state.render = data.render;
        },

        /**
         * Мутация устанавливает данные о выбранных зданиях.
         * @param {object} state - текущий стейт.
         * @param {object} data - данные из фильтра
         */
        SET_SELECTED_BUILDINGS(state, data) {
            // eslint-disable-next-line no-unused-expressions,no-undef
            state.selected.includes(Number(data.building[item].id)) ?
                // eslint-disable-next-line no-undef
                state.selected.splice(state.selected.indexOf(Number(data.building[item].id)), 1) :
                // eslint-disable-next-line no-undef
                state.selected.push(Number(data.building[item].id));
        },

        /**
         * Мутация устанавливает данные о выбранных зданиях.
         * @param {object} state - текущий стейт.
         * @param {object} data - данные из фильтра
         */
        SET_SELECTED_BUILDINGS_FROM_SELECT(state, data) {
            state.selected = data;
        },

        /**
         * Мутация устанавливает текущий массив квартир исходя из объекта.
         * @param {object} state - текущий стейт.
         * @param {object} data - данные от сервера
         */
        SET_FLATS(state, data) {
            state.flats = [];
            // т.к еще нет группировки по корпусам, выбираем первый элемент ассоциативного массива
            const defaultObject = Object.keys(data.objects)[0];
            const currentObject = data.objects[defaultObject];
            const warning = 'В массиве flats нет квартиры с данным id = ';

            if (!currentObject) {
                return;
            }

            currentObject.flats.forEach((item) => {
                return data.flats[item] ? state.flats.push(data.flats[item]) : console.warn(`${warning}${[item]}`);
            });

            state.allFlats = data.flats;
        },

        /**
         * Мутация генерит событие на изменения границ для слайдера
         * @param {object} state - текущий стейт.
         * @param {object} data - данные от сервера
         */
        UPDATE_BORDER_SLIDERS(state, data) {
            // конвертируем объект в массив
            const borders = Object.keys(data.sliders).map((i) => {
                return {[i]: data.sliders[i]};
            });

            // передаем range-слайдеру обновленные границы
            observer.publish('parametricfilterSend', borders);
        },

        /**
         * Мутация устанавливает текущую страницу пагинация, и добавляет ее в гет
         * @param {object} state - текущий стейт.
         */
        SET_PAGE(state) {
            state.page = Number(state.page) + defaultPage;
            this.commit('SET_GET_PARAMS');
        },

        /**
         * Мутация устанавливает текущее направление и тип сортировки, и добавляет ее в гет
         * @param {object} state - текущий стейт.
         * @param {object} body - объект с данными об установленной сортировки, приходит из компонента Sort
         */
        SET_SORT(state, body) {
            state.sort.type = body.type;
            state.sort.order = body.order;

            this.commit('SET_GET_PARAMS');
        },

        /**
         * Мутация устанавливает тип параметрического выборщика
         * @param {object} state - текущий стейт.
         */
        SET_ESTATETYPE(state) {
            state.estateType = this._vm.$appOptions.estateType;
        },

        SET_HIDDENPRICES(state, data) {
            state.hiddenPrices = data.hiddenPrices || false;
        }
    }
});
